const root = 'resetPasswordSuccessMessage'

export const TestId = {
  goToSignInButton: `${root}-goToSignInButton`,
}
